import React, { Component } from 'react'
import {
  Form,
  Button,
  Grid,
  Icon,
  Popup,
  Loader
} from 'semantic-ui-react'
import { connect } from 'react-redux'
import SelecTextField from '../formComponents/selectTextField'
import InputField from '../formComponents/inputField'
import CustomCheckBox from '../formComponents/checkBox'
import * as actionCreators from '../actions'
import InvoiceItems from "./merchandiseSections/InvoiceItems"
import { createInvoice } from '../api/createItem'
import { get } from 'lodash'
import PscHeaderReason from "./headerReason";
import {loadCurrenciesAssociatedWithCountry, saveAdditionDeduction, saveDescriptionOfMerchandiseField} from '../api/setFormData'
import _ from 'lodash'
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
import { sumGrossWeight } from '../reducer/util'
import AdditionDeduction from './AdditionDeduction/index'

const SameAsHeader = ({
  checkboxValue,
  handleCheckBoxChange,
  headerPartyType,
  label,
  disabled
}) => {
  if (headerPartyType === 'SELLER') return null
  return (
    <Form.Group>
      <CustomCheckBox
        label={label}
        value={checkboxValue}
        update={handleCheckBoxChange}
        disabled={disabled}
      />
    </Form.Group>
  )
}

class InvoiceForm extends Component {
  constructor() {
    super()
    this.state = {
      isAdding: false,
      grossWeightWeightTouched: false,
      grossWeightUnitsTouched: false,
      articleSetModal: false,
      countriesToCurrenciesConv: {},
    }
  }

  updateAddStatus = () => {
    this.setState({
      isAdding: false
    })
  }

  displayWeightInkg = (unit, weight) => {
    if (unit === 'LB') {
      return (
        <span
          style={{
            fontStyle: 'italic',
            fontSize: '12px',
          }}
        >
          Weight in KG : {(parseFloat(weight) * 0.453592).toFixed(2)}
        </span>
      )
    }
  }

  enableDisableFrom = (enableLineItem) => {
    this.setState({
      "enableLineItem": enableLineItem
    })
  }
  componentDidUpdate(){
    let {  
      countryOfExport
    } = this.props
    
    if(!this.state.countriesToCurrenciesConv[countryOfExport]){
      
      let currentObject2 = this.state.countriesToCurrenciesConv;
      currentObject2[countryOfExport] =  [];
      this.setState({countriesToCurrenciesConv:currentObject2});

      loadCurrenciesAssociatedWithCountry(countryOfExport).then(response=>{
        let currentObject = this.state.countriesToCurrenciesConv;
        currentObject[countryOfExport] =  _.get(response,"data.eventMessage.currencyCodes",[])
        this.setState({countriesToCurrenciesConv:currentObject});

      })
    }
  }
  
  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }
  
  componentWillReceiveProps() {
    if(this.props.pscData.pscShipmentId){
      this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
      const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
      this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
    }
  }

  render() {
    let isBrokerKnAdmin = get(this.props, 'kxUserBasicInfo.typeOfUser', '') === 'BROKER_KN_ADMIN';
    const {
      updateMerchObject,
      updateMerchFeild,
      grossWeightWeight,
      grossWeightWeightUnits,
      saveMerchandiseField,
      totalValue,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      // totalLineItemWeight,
      rbCounterID,
      updateLineItemWeightsBasedonTotalValueAndGrossWeight,
      isDisabled,
      totalInvoiceItem,
      shipmentETA,
      totalCharges,
      saveHeaderReason,
      countryOfExport,
      tariffsLoader,
      totalAdditions,
      totalDeletions

    } = this.props
    const totalLineItemWeight = sumGrossWeight(this.props?.descriptionOfMerchandiseValues?.entrySummaryInvoices);
    //const shipmentCountry = window.shipmentCountry || "US";
   // let jobWheel = getJobWheels(shipmentCountry, currentJobData);
   // let bhHouseKey = jobWheel['SHIPMENT_BROKER_HOUSE_PROCESS'] ? jobWheel["SHIPMENT_BROKER_HOUSE_PROCESS"].value.state : null; 

   // let formDisabled = this.props.formDisabled || bhHouseKey === "STATE_BH_ASSIGNED";
   let formDisabled = this.props.formDisabled
    //console.log('STATE_BH_BROKER_ASSIGNED ::', formDisabled)
    let pscWarningAlertShow = this.selectedReasons.length<=0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY')


      const isTheOwningBroker = !this.props?.kxUserBasicInfo?.userGuid ||  !this.props?.currentJobData?.brokerGuid || this.props?.kxUserBasicInfo?.userGuid  == this.props?.currentJobData?.brokerGuid;
       let isPSCEditable = isTheOwningBroker && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY');
  

    //copied from      sumGrossWeight
    const sumTotalCharges = invoiceItems => {
      let sumTotalChargesValue = 0;
      for (let invoiceItem of (invoiceItems || [])) {
        for (let lineItem of invoiceItem.merchandiseLineItems) {
          if (lineItem.articleHeader != "V") {
            for (let oneDuty of (lineItem?.merchandiseDuties || [])) {
              if (oneDuty.isCommodityDuty != 1) continue;
              let addedCharge = parseFloat(oneDuty.charges) || 0;
              if (addedCharge < 0) addedCharge = 0;
              sumTotalChargesValue += addedCharge;
            }
          }
        }
      }
      return sumTotalChargesValue;
    }

    sumTotalCharges(this.props?.descriptionOfMerchandiseValues?.entrySummaryInvoices || []);
    let grossWeightError = (this.props?.fieldValidation?.warnings || []).find(aaa=>aaa.targetName_c == "adcvdtggtGrossWeight");
    return (
      <React.Fragment>
        {/* <DropDown
          id='usStateOfDestCode'
          label='STATE OF ULTIMATE DESTINATION'
          isLabel={true}
          className='dropdown100'
          disabled={isDisabled('usStateOfDestCode')}
          data={USStatesList}
          text={displayMasterItem(usStateOfDestCode, USStatesList)}
          onChange={value => {
            updateField('usStateOfDestCode', value)
            saveImporterField('usStateOfDestCode', value)
          }}
        />
        <br />
        <SameAsHeader
          id='related'
          dropDownValue='Importer'
          dropDownValues={['Importer']}
          label='Importer related to Seller and/or Manufacturer?'
          handleCheckBoxChange={value => {
            updateField('related', value ? 1 : 2)
            saveImporterField('related', value ? 1 : 2)
          }}
          handleDropDownChange={() => { }}
          checkboxValue={Boolean(related === 1)}
          disabled={isDisabled('related')}
        /> */}
        <Form className='MerchandiseForm' autoComplete='off' title={pscWarningAlertShow?"Must select a PSC reason before you can edit":""}>
          <Grid>
            {(get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && 
              <Grid.Row>
                <Grid.Column>
                  <PscHeaderReason 
                    {...this.props}
                    totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
                    selectedOptions={this.selectedReasons}
                    saveHeaderReason={saveHeaderReason} 
                    enableDisableFrom={this.enableDisableFrom}
                    pscState={get(this.props, "pscState.value.state")}
                  />
                </Grid.Column>
              </Grid.Row>
            }
            <Grid.Row className='total-box-row'>
              <Grid.Column className='total-box-container shipmentSummary'>
               <div className='total-box shipmentSummary-box'>
                  <div className='title'>
                    <b>TOTAL VALUE</b>
                    <Popup
                      trigger={<Icon name='info circle' color='blue' />}
                      content='Total Value cannot be edited. Total Value from line items will be transmitted on completion of the form.'
                    />
                  </div>
                  <InputField
                    id={'totalValue'}
                    disabled={true || Boolean(formDisabled)}
                    type={'text'}
                    className={'field-bg total-vals'}
                    formDisabled
                    subLabelText='$'
                    subLabelClass='left-icon no-label'
                    value={totalValue}
                    isInteger={true}
                    onChange={value => {
                      updateMerchFeild(
                        'totalValue',
                        value.replace(/[^\d.-]/g, '')
                      )
                    }}
                    onBlur={value => {
                      updateMerchFeild(
                        'totalValue',
                        Math.round(parseFloat(value || 0)).toFixed(2)
                      )
                      saveMerchandiseField('totalValue')
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  <div className='total-line-item'>
                    <i>Calculated from Line Items</i>
                  </div>
                </div>               

                <div className='total-box shipmentSummary-box'> 
                  <div className='title'>
                    <b>GROSS WEIGHT</b>
                    <Popup
                      trigger={<Icon name='info circle' color='blue' />}
                      content='Gross Weight can be edited. Total from line items is given for reference. The values should match upon completion of Merchandise Section.'
                    />
                    {grossWeightError && 
                        <Popup
                          trigger={<Icon name='warning sign' color='red' />}
                          content={grossWeightError.msg}
                        />
                      }
                  </div>
                  <SelecTextField
                    isLabel={false}
                    divClassName='total-vals'
                    inputName='grossWeight.weight'
                    selectName='grossWeight.weightUnits'
                    type='text'
                    className={'field-bg total-vals'}
                    options={['KG', 'LB']}
                    isInteger={true}
                    shortSelectText={true}
                    handleFocus={e => {
                      e.target.select()
                      this.setState({
                        grossWeightWeightTouched: false,
                        grossWeightUnitsTouched: false
                      })
                    }}
                    updateValue={value => {
                      updateMerchObject(
                        'grossWeight',
                        'weight',
                        value.replace(/[^\d.-]/g, '')
                      )
                      this.setState({
                        grossWeightWeightTouched: true
                      })
                    }}
                    updateDropDownValue={value => {
                      updateMerchObject('grossWeight', 'weightUnits', value)
                      this.setState({
                        grossWeightUnitsTouched: true
                      })
                    }}
                    value={grossWeightWeight}
                    dropDownValue={grossWeightWeightUnits.toUpperCase()}
                    onBlur={value => {
                      // Only cause updates if one of the values was changed
                      if (
                        this.state.grossWeightWeightTouched ||
                        this.state.grossWeightUnitsTouched
                      ) {
                        // Update and Save Values
                        updateMerchObject(
                          'grossWeight',
                          'weight',
                          parseFloat(grossWeightWeight || 0).toFixed(2)
                        )
                        saveMerchandiseField('grossWeight')
                        // // Update Suggested Total from new line item weights
                        // updateTotalValueAndGrossWeight()
                      }
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                    disabled={this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight')}
                  />
                  <div className='total-line-item'>
                    <i>Calculated Total: {`${totalLineItemWeight || ''} KG`}</i>
                  </div>
                  {this.displayWeightInkg(
                    grossWeightWeightUnits,
                    grossWeightWeight
                  )}

                  {totalValue == 0.0 && <span style={{color:'#aaa'}}>Entered value must be &gt; 0.0</span>}
                  <Button
                    className={'calculate-btn prorate-btn'}
                    basic
                    id={`recalculateLineItemWeights${shipmentId}`}
                    color='blue'
                    circular
                    compact
                    disabled={this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight')}
                    onClick={() => {
                      // Update Line Item Weights based on new Gross Weight
                      updateLineItemWeightsBasedonTotalValueAndGrossWeight()
                      
                      document.getElementById("VALIDATE_FORM_BUTTON") &&
                      document.getElementById("VALIDATE_FORM_BUTTON").click();
                    }}
                  >
                    Calculate Line Items 
                    <div style={{border:'1px solid rgba(0,0,0,.2)',
                        float:'right',
                        borderRadius: '7px',
                        marginTop: "-2px",
                        marginLeft: "4px",
                        padding: "1px",
                        paddingLeft: "7px",
                        paddingRight: "6px",
                        marginBottom: "-2px",
                        cursor:"pointer",
                      }}
                    onClick={(e)=>{
                      localStorage.setItem("disableAutoCalculate",localStorage.getItem("disableAutoCalculate")=='true'?'false':'true');
                      this.setState({})
                      e.stopPropagation();
                      return false;
                    }}
                    >
                    
                    
                    <Popup
                        trigger={<span>
                          <input type="checkbox" style={{cursor:'pointer'}} checked={localStorage.getItem("disableAutoCalculate")!="true"}
                          onChange={()=>{/*react was complaining*/}}
                          />
                          Auto
                        </span>}
                        content={"If this box is checked, gross weight will be proportionally allocated when editing this shipment. Uncheck to manually enter."}
                      />
                    </div>
                  </Button>
                </div>
                <div className='total-box shipmentSummary-box'>
                  <div className='title'>
                    <b>TOTAL CHARGES</b>
                  </div>
                  <InputField
                    id={'totalCharges'}
                    disabled={this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight')}
                    type={'text'}
                    className={'field-bg total-vals'}
                    formDisabled
                    subLabelText='$'
                    subLabelClass='left-icon no-label'
                    value={this.state.hasTotalChargesChange
                      ?this.state.totalChargesNewValue
                      :totalCharges}
                    isInteger={true}
                    onChange={value => {
                      this.setState({totalChargesNewValue: value.replace(/[^\d.-]/g, ''),
                        hasTotalChargesChange: true});
                    }}
                    onBlur={value => {
                    }}
                    newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                  />
                  Calculated Total: ${sumTotalCharges(this.props?.descriptionOfMerchandiseValues?.entrySummaryInvoices || [])}
                  <br/>
                  
                  {<>
                    <Button style={{display:'none'}}>
                    </Button>
                    <Button
                      className={'calculate-btn prorate-btn'}
                      basic
                      color='blue'
                      circular
                      compact
                      disabled={
                        (this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight'))}
                      onClick={() => {
                        let newTotalCharges = this.state.hasTotalChargesChange
                        ?this.state.totalChargesNewValue
                        :totalCharges;
                        updateMerchFeild(
                          'totalCharges',
                          Math.round(parseFloat(newTotalCharges || 0)).toFixed(2)
                        )
                        saveDescriptionOfMerchandiseField('totalCharges',newTotalCharges);
                        
                        this.setState({ totalChargesNewValue: null, hasTotalChargesChange:false });
                      }}
                    >
                      Save & Prorate
                    </Button>
                    <Button
                      className={'calculate-btn prorate-btn'}
                      basic
                      color='blue'
                      circular
                      compact
                      disabled={!this.state.hasTotalChargesChange ||
                        (this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight'))}
                      onClick={() => {
                        this.setState({ totalChargesNewValue: null, hasTotalChargesChange:false });
                      }}
                    >
                      Cancel
                    </Button>

                  </>}
                </div>
                 <AdditionDeduction newValue={newValue}
                    fieldName={fieldName}
                    setINPUTID={setINPUTID}
                    penClicked={penClicked}
                    shipmentId={shipmentId}
                    rbCounterID={rbCounterID}
                    totalAdditions={totalAdditions}
                    totalDeletions={totalDeletions}
                    updateMerchFeild={updateMerchFeild}
                    saveAdditionDeduction={saveAdditionDeduction}
                    disabled={this.state.enableLineItem === true ? false : isDisabled('grossWeight.weight')}
                     />
              </Grid.Column>
             
            </Grid.Row>
           
          </Grid>
          <InvoiceItems pscState={get(this.props, "pscState.value.state")} refreshESFrom={this.props.refreshESFrom} modeOfTransport={this.props.modeOfTransport} validateFormzz={this.props.validateFormzz} expandAll={this.props.expandAll} isDisabled={isDisabled} 
          shipmentETA={shipmentETA} isBrokerKnAdmin={isBrokerKnAdmin}
          countriesToCurrenciesConv={this.state.countriesToCurrenciesConv}
                    {...this.props}
          />
           <Grid padded>
            <Grid.Row className='add-merch-line-item'>
              <Grid.Column>
                
                <Button
                  className={'add-line-item-btn'}
                  basic
                  color='blue'
                  circular
                  compact
                  onClick={() => {
                    this.setState({
                      isAdding: true
                    })
                    createInvoice(totalInvoiceItem,this.updateAddStatus,get(this.props, "pscData.pscShipmentId") || get(this.props, "shipmentId") )
                  }}
                  disabled={isPSCEditable ? false : 
                  isDisabled('addRemoveMerchandiseLineItems',Boolean(formDisabled))
                }
                >
                  {!this.state.isAdding ? (
                    <span>
                      <Icon name='add circle' /> Add Invoice {/*Add Invoice Line Item*/}
                    </span>
                  ) : (
                      <span>
                        <Loader
                          active
                          inline
                          size='mini'
                          style={{ marginRight: '10px' }}
                        />
                        Adding 
                        Invoice
                    </span>
                    )}
                </Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, props) => ({
  fieldValidation: state.FieldValidation,
  totalEnteredValue: state.DescriptionOfMerchandise.totalEnteredValue,
  // totalLineItemWeight: state.DescriptionOfMerchandise.totalLineItemWeight,
  totalCharges: state.DescriptionOfMerchandise.totalCharges,
  totalInvoiceItem: state.DescriptionOfMerchandise.entrySummaryInvoices.length,
  descriptionOfMerchandiseValues: state.DescriptionOfMerchandise,
  grossWeightWeight: state.DescriptionOfMerchandise.grossWeight.weight,
  grossWeightWeightUnits:
    state.DescriptionOfMerchandise.grossWeight.weightUnits,
  manifestQuantityQuantity:
    state.DescriptionOfMerchandise.manifestQuantity.quantity,
  manifestQuantityUnits: state.DescriptionOfMerchandise.manifestQuantity.units,
  manufacturerId: state.DescriptionOfMerchandise.manufacturerId,
  duty: state.DescriptionOfMerchandise.duty,
  grandTotal: state.DescriptionOfMerchandise.grandTotal,
  fee: state.DescriptionOfMerchandise.fee,
  tax: state.DescriptionOfMerchandise.tax,
  hmf: state.DescriptionOfMerchandise.hmf,
  mpf: state.DescriptionOfMerchandise.mpf,
  userFees: state.DescriptionOfMerchandise.additionalDuties.userFees,
  exporttDateEpoch: state.DescriptionOfMerchandise.exportDate.epochs,
  weightUnitsList: state.DropDownValues.weightUnitsList,
  unitList: state.DropDownValues.unitList,
  totalValue: state.DescriptionOfMerchandise.totalValue,
  tariffsLoader:  state.DescriptionOfMerchandise.tariffsLoader,
  USStatesList: state.DropDownValues.USStatesList,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  shipmentId: state.FormValues.shipmentId,
  rbCounterID: state.FormValues.rbCounterID,
  formDisabled: state.FormValues.formDisabled,
  usStateOfDestCode: state.Importer.usStateOfDestCode,
  related: state.Importer.related,
  countryOfExport: state.EntryTypeInfo.countryOfExport,
  tabName: "merchandise", 
  pscData: state.PSC,
  totalDeletions: state.DescriptionOfMerchandise.totalDeletions,
  totalAdditions: state.DescriptionOfMerchandise.totalAdditions,
})

const mapDispatchToProps = {
  ...actionCreators
}

export default React.memo(connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceForm))
